// src/v3/consts/stockStatus.ts
var OUT_OF_STOCK = "outOfStock";
var LOW_STOCK = "lowStock";
var IN_STOCK = "inStock";
export {
  IN_STOCK,
  LOW_STOCK,
  OUT_OF_STOCK
};
//# sourceMappingURL=stockStatus.mjs.map